import styled from '@emotion/styled';

import { BREAKPOINTS } from 'utils/constants';

export const AppNoticeContent = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  gap: var(--spacing-l4);

  @media (max-width: ${BREAKPOINTS.laptop}) {
    gap: var(--spacing-l2);
  }

  ul,
  ol {
    list-style: revert;
    padding: 0 1rem;
  }

  p:empty {
    height: 1em;
  }

  &:not(:last-child) {
    margin-bottom: var(--spacing-l6);

    &:after {
      content: '';
      display: block;
      background-color: var(--border);
      position: absolute;
      width: 100%;
      height: 1px;
      bottom: calc(var(--spacing-l6) / 2 * -1);
    }
  }
`;

export const Title = styled.div`
  display: flex;
  align-items: center;
  gap: var(--spacing-l2);
  justify-content: space-between;
`;

export const DateText = styled.span`
  font: var(--body-2);
  color: var(--text-subtle);
`;

export const TextWrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-template-areas: 'title title' 'image message';
  row-gap: var(--spacing-l2);
  column-gap: var(--spacing-l4);
  padding: var(--spacing-l1);

  &[data-variant='untitled'] {
    grid-template-areas: 'image message';
  }

  &[data-image-position='right'] {
    grid-template-areas: 'title title' 'message image';

    &[data-variant='untitled'] {
      grid-template-areas: 'message image';
    }
  }
`;

export const TextTitle = styled.div`
  grid-area: title;
  font: var(--h4);
  text-align: center;
`;

export const TextMessage = styled.div`
  grid-area: message;
  font: var(--body-2);

  * {
    font: var(--body-2);
  }
`;

export const ImageWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 120px;
`;

export const Link = styled.a`
  display: flex;
  text-decoration: none;
`;

export const Image = styled.img`
  max-width: 100%;
  height: auto;
  object-fit: contain;
`;
